export type ParticipantList = {
  "@id": string;
  "@type": string;
  id: number;
  date: string;
};

export type DishNutritionDataset = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  file: string;
  month: number;
  year: number;
};
